<template>
  <section>
    <!--工具条-->
    <div>
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="filters.vehicleErpCode" placeholder="车号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.stationLineName" filterable remote allow-create default-first-option
            :clearable="true" placeholder="生产线">
            <el-option v-for=" item in stationOptions " :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.billType" filterable remote allow-create default-first-option :clearable="true"
            placeholder="请票据类型">
            <el-option v-for=" item in options " :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker type="datetime" placeholder="开始日期" v-model="filters.startTime"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          <el-date-picker type="datetime" placeholder="结束日期" v-model="filters.endTime"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getReportList(1)">查询</el-button>
          <el-button type="primary" @click="downReport">导出</el-button>
        </el-form-item>
      </el-form>

    </div>
    <!--列表-->
    <el-table :data="dmList" highlight-current-row v-loading="listLoading" style="width: 100%" border show-summary
      :summary-method="getSummaries">

      <el-table-column prop="VehicleErpCode" label="车号"></el-table-column>
      <el-table-column label="混凝土方量">
        <template slot-scope="scope">
          <div>
            {{ Number(scope.row.TQuantity) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="砂浆方量">
        <template slot-scope="scope">
          <div>
            {{ Number(scope.row.SQuantity) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="QuantityDelivery" label="发货方量"></el-table-column>
      <el-table-column prop="VehiclesTotal" label="总趟数"></el-table-column>
      <el-table-column label="票据类型">
        <template slot-scope="scope">
          <div>
            {{ scope.row.BillType == 0 ? '送料' : scope.row.BillType == 100 ? '砂浆' : scope.row.BillType == 200 ? '拉水' :
              scope.row.BillType == 300 ? '补方' : scope.row.BillType == 400 ? '其他' : '补单' }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="filters.intPageSize" :total="total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange" class="my-pagination"></el-pagination>
  </section>
</template>

<script>
//引入Material.js的所有export的对象,并起别名为api,通过api.***访问成员
import * as api from "../../api/command";
import { getSysStationLineListPage } from "../../api/recipe";
import Toolbar from "../../components/Toolbar";
import util from "../../../util/date";
export default {
  components: { Toolbar },
  data() {
    return {
      currentRow: null,
      filters: {
        startTime: "",
        endTime: "",
        billType: '-1',
        vehicleErpCode: "",
        stationLineName: "",
        page: 1,
        intPageSize: 20,
      },
      orgId: '',
      orgList: [],
      total: 0,
      dmList: [],
      sumData: {},
      listLoading: false,
      options: [{
        value: '-1',
        label: '全部'
      }, {
        value: '0',
        label: '送料'
      }, {
        value: '100',
        label: '砂浆'
      }, {
        value: '200',
        label: '拉水'
      }, {
        value: '300',
        label: '补方'
      }, {
        value: '400',
        label: '其他'
      }],
      stationOptions: [],
    };
  },
  computed: {},
  methods: {
    getSummaries(param) {
      var sums = [];
      sums[0] = "合计";
      sums[1] = this.sumData.TQuantity;
      sums[2] = this.sumData.SQuantity;
      sums[3] = this.sumData.QuantityDelivery;
      sums[4] = this.sumData.VehiclesTotal;
      sums[5] = "";

      return sums;
    },
    //工具条绑定事件方法
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.filters.page = val;
      this.getReportList();
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.filters.intPageSize = size;
      this.getReportList();
    },
    //获取原材料消耗
    getReportList(optype) {
      if (optype == 1) {
        this.filters.page = 1;
      }
      let para = this.filters;
      this.listLoading = true;
      this.dmList = [];
      api
        .GetProdVehicleGroup(para)
        .then((res) => {
          if (res && res.data && res.data.response && res.data.response.data)
            this.dmList = res.data.response.data;
          this.sumData = res.data.responsesum;
          this.total = res.data.response.dataCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //获取生产线列表
    getSysStationLineList(orgId) {
      let para = {
        key: orgId,
      };
      this.listLoading = true;
      let that = this;
      getSysStationLineListPage(para)
        .then((res) => {
          that.stationOptions.push({
            value: '',
            label: '全部'
          });
          if (res.data.response.data.length > 0) {
            res.data.response.data.map(k => {
              that.stationOptions.push({
                value: k.Name,
                label: k.Name
              });

            });
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //导出原材料消耗
    downReport() {
      let para = this.filters;
      var sheetName = "车辆出车统计表";
      api.DownProdVehicleGroup(para, sheetName).then((res) => { });
    },
    formatTimeYMD(row, column) {
      return !row.ProductionTime || row.ProductionTime == ""
        ? ""
        : util.formatDate.format(new Date(row.ProductionTime), "yyyy/MM/dd");
    },
    formatTimeHMS(row, column) {
      return !row.ProductionTime || row.ProductionTime == ""
        ? ""
        : util.formatDate.format(new Date(row.ProductionTime), "hh:mm:ss");
    }, formatDate(date) {
      function padZero(num) {
        return num < 10 ? '0' + num : num;
      }
      var year = date.getFullYear();
      var month = padZero(date.getMonth() + 1); // 月份是从0开始的
      var day = padZero(date.getDate());
      var hours = padZero(date.getHours());
      var minutes = padZero(date.getMinutes());
      var seconds = padZero(date.getSeconds());

      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    },
  },
  mounted() {
    //获取搅拌站信息
    if (localStorage.sysOrgs) {
      this.orgList = JSON.parse(localStorage.sysOrgs);
    }
    /*获取出货单基础档案*/
    if (this.orgId == "") {
      if (localStorage.currentOrg) {
        this.orgId = JSON.parse(localStorage.currentOrg).Id;
      } else if (this.orgList) {
        this.orgId = this.orgList[0].Id;
      }
    }
    let pastDate = new Date(new Date().setHours(0, 0, 0, 0));
    pastDate.setDate(pastDate.getDate()); //num正数为后一天，负数为前一天
    this.filters.startTime = this.formatDate(pastDate);

    let endDate = new Date(new Date().setHours(23, 59, 59, 0));
    endDate.setDate(endDate.getDate()); //num正数为后一天，负数为前一天
    this.filters.endTime = this.formatDate(endDate);
    this.getReportList();
    this.getSysStationLineList(this.orgId);
  },
};
</script>

<style lang="less" scoped>
.input-select {
  width: 300px;
}
</style>
